import orderdetailApi from '@/api/Methods/Order/Order-Detail-API-Methods';
import warehouseApi from '@/api/Methods/Order/Warehouse-API-Methods';
import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";
export default {
    methods: {
        async getJobOrder(jobId) {
            var meta = { clientApiMethod: 'getJobOrder', input: { jobId: jobId } }
            var response = await client().get(store.state.apiRouteRoot + "Order/AllJobOrders/" + jobId, { meta: meta })
            return response?.data;
        },
        async getOrderTotalByOrderId(orderId) {
            var meta = { clientApiMethod: 'getOrderTotalByOrderId', input: { orderId: orderId } }
            var response = await client().get(store.state.apiRouteRoot + "Order/GetTotal/" + orderId, { meta: meta })
            return response?.data;
        },
        async saveParentOrderOptions(parentorder) {
            var meta = {
                clientApiMethod: 'saveParentOrderOptions',
                input: { parentorder },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.order.order") })
            }
            const params = {
                departmentId: parentorder.DepartmentId,
                projectId: parentorder.ProjectId,
                invoiceReference: parentorder.InvoiceReference,
                serviceManagerComment: parentorder.ServiceManagerComment,
                noInvoice: parentorder.NoInvoice
            };
            var response = await client().patch(store.state.apiRouteRoot + "Order/OrderOptions/" + parentorder.JobId, null, { params: params, meta: meta })
            return response?.data;
        },
        ...orderdetailApi.methods,
        ...warehouseApi.methods,
        async getPartsByJobId(jobId) {
            var meta = { clientApiMethod: 'getPartsByJobId', input: { jobId: jobId } }
            var response = await client().get(store.state.apiRouteRoot + "orderdetail/jobview/" + jobId, { meta: meta })
            return response?.data;
        },
        async searchArticleByString(query) {
            var meta = { clientApiMethod: 'searchArticleByString', input: { query: query } }
            var querystring = encodeURI(query)
            var response = await client().get('/api2/serviceprovider/article/search?q=' + querystring, { meta: meta })
            return response?.data;
        },
        async getArticleListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getArticleListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "Article/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },
        async getArticleById(articleNumber) {
            var meta = { clientApiMethod: 'getArticleById', input: { articleNumber: articleNumber } }
            var response = await client().get(store.state.apiRouteRoot + "Article/" + articleNumber, { meta: meta })
            return response?.data;
        },
    }
}